import React, { useState, useEffect, useRef } from 'react';
import {Tab, Nav, Card, Button} from 'react-bootstrap';
import UserCategories from './usercategories';
import Lists from './lists';
import Downloads from './downloads';

const USER_CATEGORIES_TAB = 'mycategories';
const LISTS_TAB = 'mylists';
const DOWNLOADS_TAB = 'mydownloads';

function MyContent(props) {
    const ucgRef = useRef(null);
    const listRef = useRef(null);
    
    const [activeTab, setActiveTab] = useState(LISTS_TAB);

    const [showUCGGridView, setShowUCGGridView] = useState(true);
    const [forceUCGRefresh, setForceUCGRefresh] = useState(false);
    const passForceUCGRefresh = () => (setForceUCGRefresh(!forceUCGRefresh));
    const [updatingUCGData, setUpdatingUCGData] = useState(false);
    const passUpdatingUCGData = (data) => (setUpdatingUCGData(data));
    const [selectedUCGId, setSelectedUCGId] = useState(0);
    const passSelectedUCGId = (data) => { setSelectedUCGId(data) };

    const [showListGridView, setShowListGridView] = useState(true);
    const [forceListRefresh, setForceListRefresh] = useState(false);
    const passForceListRefresh = () => (setForceListRefresh(!forceListRefresh));
    const [updatingListData, setUpdatingListData] = useState(false);
    const passUpdatingListData = (data) => (setUpdatingListData(data));
    const [selectedListId, setSelectedListId] = useState(0);
    const passSelectedListId = (data) => { setSelectedListId(data) };

    const tabRefresh = () => {
        if (activeTab === USER_CATEGORIES_TAB) {
            setForceUCGRefresh(!forceUCGRefresh)
        } else if (activeTab === LISTS_TAB) {
            setForceListRefresh(!forceListRefresh)
        }
    }    
    
    const handleTabSelection = (key) => {
        setActiveTab(key);
    };

    useEffect(() => {
        if ((activeTab === USER_CATEGORIES_TAB) && (!updatingUCGData)) {
            ucgRef.current?.fetchData();
        }
    }, [forceUCGRefresh]);

    useEffect(() => {
        ucgRef.current?.toggleView(!showUCGGridView);
    }, [showUCGGridView]);

    const toggleUCGView = () => {
        setShowUCGGridView(!showUCGGridView)
    }

    const newUCG = () => {
        ucgRef.current?.setCategoryModalNew(true);
        ucgRef.current?.openCategoryModal();
    }

    useEffect(() => {
        if ((activeTab === LISTS_TAB) && (!updatingListData)) {
            listRef.current?.fetchData();
        }
    }, [forceListRefresh]);

    useEffect(() => {
        listRef.current?.toggleView(!showListGridView);
    }, [showListGridView]);
    
    const toggleListView = () => {
        setShowListGridView(!showListGridView)
    }

    return (
        <div className='container-fluid h-100 p-0'>
            <Tab.Container defaultActiveKey={LISTS_TAB} onSelect={handleTabSelection} activeKey={activeTab}>
                <Nav variant='tabs' className='fs-6 border' >
                    <Nav.Item><Nav.Link eventKey={LISTS_TAB}>My Lists{updatingListData ? (<React.Fragment>&nbsp;<i className="fa fa-spinner fa-pulse text-white"></i></React.Fragment>) : ''}</Nav.Link></Nav.Item>
                    <Nav.Item><Nav.Link eventKey={USER_CATEGORIES_TAB}>My Categories{updatingUCGData ? (<React.Fragment>&nbsp;<i className="fa fa-spinner fa-pulse text-white"></i></React.Fragment>) : ''}</Nav.Link></Nav.Item>
                    <Nav.Item><Nav.Link eventKey={DOWNLOADS_TAB}>My Downloads</Nav.Link></Nav.Item>
                    <Nav.Item className='ms-auto my-auto'>
                        {(activeTab === USER_CATEGORIES_TAB) ? (<>
                        <Button title="New Category Group" className={`btn btn-primary mx-1 float-right`} onClick={newUCG}><i class={`bi bi-plus text-white`} style={{fontWeight:'bold'}}></i></Button>
                        <Button title="Grid / Cards" className={`btn btn-primary mx-1 float-right`} onClick={toggleUCGView}><i className={`bi ${showUCGGridView ? 'bi-list' : 'bi-grid'}`}></i></Button>
                        </>) : <></>}
                        {(activeTab === LISTS_TAB) ? (<>
                        <Button title="Grid / Cards" className={`btn btn-primary mx-1 float-right`} onClick={toggleListView}><i className={`bi ${showListGridView ? 'bi-list' : 'bi-grid'}`}></i></Button>
                        </>) : <></>}
                        <Button title="Refresh" className={`btn btn-primary mx-1 float-right`} onClick={tabRefresh}><i className={`bi bi-arrow-repeat`}></i></Button>
                    </Nav.Item>                
                </Nav>
                <Tab.Content className='w-100' style={{ height: "calc(100% - 34px)" }} animation="true" mountOnEnter={true} unmountOnExit={true} >
                    <Tab.Pane className='w-100 h-100' eventKey={LISTS_TAB} title="My Lists">
                        <Card className={`w-100 h-100 overflow-auto`}>
                            <Lists ref={listRef} uid={props.uid} urd={passUpdatingListData} slu={passSelectedListId} pfr={passForceListRefresh} />
                        </Card>
                    </Tab.Pane>
                    <Tab.Pane className='w-100 h-100' eventKey={USER_CATEGORIES_TAB} title="My Categories">
                        <Card className={`w-100 h-100 overflow-auto`}>
                            <UserCategories ref={ucgRef} uid={props.uid} uucgd={passUpdatingUCGData} sucgu={passSelectedUCGId} pfr={passForceUCGRefresh} />
                        </Card>
                    </Tab.Pane>
                    <Tab.Pane className='w-100 h-100' eventKey={DOWNLOADS_TAB} title="My Downloads">
                        <Downloads userid={props.uid}/>
                    </Tab.Pane>
                </Tab.Content>
            </Tab.Container>
        </div>
    )
}

export default MyContent;